import React, { useState } from "react"
import ReactApexChart from "react-apexcharts"
import { uniqBy } from "../../utils/collectionUtils"
import { MultiValueLabel, Option } from "../../components/pricetable/PPShopPreset"
import { PPDefaultSelector } from "../../components/ui/PPDefaultSelector"
import { useTranslation } from "react-i18next"

function getDatesFromLastTwoWeeks() {
    let start = Date.now()
    let days = 14
    let dates = []
    for (let i = 0; i < days; i++) dates.push(new Date(start - i * 1000 * 60 * 60 * 24).toLocaleDateString("de-DE"))
    dates.reverse()
    return dates
}

function prepareMappingHistoryData(series, entry, shops) {
    if (
        shops &&
        shops.length > 0 &&
        shops.map((x) => x.value).includes(entry.name + "." + entry.lang) &&
        entry.mappingCounts !== null &&
        entry.mappingCounts !== undefined
    ) {
        series.push({
            name: entry.name + "." + entry.lang,
            data: entry.mappingCounts.replace("[", "").replace("]", "").split`,`.map((x) => +x)
        })
    }
}

function buildMappingHistoryChartOptions(isDark) {
    return {
        chart: {
            background: "transparent"
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            width: 5,
            curve: "smooth",
            dashArray: 0
        },
        legend: {
            labels: {
                colors: isDark ? "#e9ecef" : undefined
            },
            tooltipHoverFormatter: function (val, opts) {
                return val + " - " + opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] + ""
            }
        },
        markers: {
            size: 4,
            hover: {
                sizeOffset: 6
            }
        },
        xaxis: {
            categories: getDatesFromLastTwoWeeks(),
            labels: {
                style: {
                    colors: isDark ? "#adb5bd" : undefined
                }
            }
        },
        yaxis: {
            labels: {
                style: {
                    colors: isDark ? "#adb5bd" : undefined
                }
            }
        },
        tooltip: {
            theme: isDark ? "dark" : "light",
            y: [
                {
                    title: {
                        formatter: function (val) {
                            return val
                        }
                    }
                }
            ]
        },
        grid: {
            borderColor: isDark ? "#495057" : "#f1f1f1"
        },
        theme: {
            mode: isDark ? "dark" : "light",
            palette: "palette2",
            monochrome: {
                enabled: false,
                color: "#255aee",
                shadeTo: isDark ? "dark" : "light",
                shadeIntensity: 0.65
            }
        }
    }
}

function ShopFilterMappingHistoryChart(props) {
    const [t] = useTranslation()
    const isDark = typeof document !== "undefined" && document.body.classList.contains("dark-mode")

    const selectorCustomStyle = {
        control: (styles) => ({
            ...styles,
            minWidth: "15em",
            backgroundColor: isDark ? "#454d55" : "#fff"
        })
    }

    const maxShops = 4

    const [shopFilter, setShopFilter] = useState(
        uniqBy(props.data?.settings?.presets[0]?.shops.map((x) => ({
            label: x.shop.name + "." + x.shop.lang,
            value: x.shop.name + "." + x.shop.lang,
            name: x.shop.name,
            lang: x.shop.lang
        })), (e) => e.value + e.lang)
    )

    let shops = uniqBy(
        props.data?.stats?.shopStats?.map((x) => ({
            label: x.name + "." + x.lang,
            value: x.name + "." + x.lang,
            name: x.name,
            lang: x.lang
        })),
        (e) => e.value + e.lang
    )

    if (shopFilter?.length > maxShops) {
        shopFilter.splice(maxShops, shopFilter.length - maxShops)
    }

    let series = []
    if (props?.data?.stats?.competitorsMappingHistory !== null) {
        props.data.stats.competitorsMappingHistory.forEach((entry) =>
            prepareMappingHistoryData(series, entry, shopFilter)
        )
        series.forEach((entry) => entry.data.reverse())
    }

    return (
        <>
            <div className="card-header d-flex flex-wrap align-items-center justify-content-between gap-2">
                <h3 className="card-title mb-0">
                    <i className="fas fa-chart-pie me-1" />
                    {props.title}
                </h3>
                <PPDefaultSelector
                    id="selectDashboardShopFilterMappingHistoryChart"
                    isMulti={true}
                    onChange={setShopFilter}
                    data={shopFilter?.length === maxShops ? [] : shops}
                    defaultValue={shopFilter}
                    components={{ MultiValueLabel, Option }}
                    noOptionsMessage={() => {
                        return shopFilter?.length === maxShops && shopFilter?.length < shops.length
                            ? t("dashboard.filter_limit")
                            : t("dashboard.filter_nooption")
                    }}
                    customStyles={selectorCustomStyle}
                />
            </div>
            <div className="card-body">
                <div className="chartDashboardMappingHistoryChart">
                    <ReactApexChart
                        options={buildMappingHistoryChartOptions(isDark)}
                        series={series}
                        type="line"
                        height={220}
                    />
                </div>
            </div>
        </>
    )
}


export { ShopFilterMappingHistoryChart }
